import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILead, leadsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { getAccessControlModule } from '../base/access-control/module';
import { actions } from './actions';
import { DEFAULT_KEY } from './constants';
import { getters } from './getters';
import { mutations } from './mutations';
import { type ILeadAggregationByOriginEntity, type ILeadAggregationByStage, type ILeadAggregationByStatus, type ILeadAggregationByType } from './types';

const LEAD_MODULE = 'lead';

const state: ILeadAggregationByStatus & ILeadAggregationByStage & ILeadAggregationByType & ILeadAggregationByOriginEntity = {
    aggregationByStatus: {
        [DEFAULT_KEY]: {
            totalCount: 0,
            byStatus: {}
        }
    },
    aggregationByType: {
        [DEFAULT_KEY]: {
            totalCount: 0,
            byType: {}
        }
    },
    aggregationByStage: {
        [DEFAULT_KEY]: {
            totalCount: 0,
            byStage: {}
        }
    },
    aggregationByOriginEntity: {
        [DEFAULT_KEY]: {
            totalCount: 0,
            byOriginEntity: {}
        }
    }
};

const dataObjectModule = getDataObjectsModule<ILead>(leadsManager, 3);
const accessControlModule = getAccessControlModule<ILead>(leadsManager);
const searchModule = getSearchModule<ILead>(leadsManager);

const leadModuleInstance = merge<unknown>(dataObjectModule, searchModule, accessControlModule, {
    state,
    actions,
    getters,
    mutations
});
store.registerModule(LEAD_MODULE, leadModuleInstance);

export { DEFAULT_KEY, LEAD_MODULE };
